import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/AntiRagging.css';

const AntiRagging = () => {
  const committeeMembers = [
    { sl: 1, name: 'Dr. M. Jayasree', designation: 'Chairman, Dean', mobile: '9443769196', email: 'jayasreevyshali@gmail.com' },
    { sl: 2, name: 'Dr. Shanmugavadivel. G', designation: 'Member, Professor of Dentistry', mobile: '7358658687', email: 'shanpedo@gmail.com' },
    { sl: 3, name: 'Dr. K. Baskaran', designation: 'Member, Professor of Biochemistry', mobile: '9894226173', email: 'drjashmi@gmail.com' },
    { sl: 4, name: 'Dr. Rajalakshmi. A', designation: 'Member, Associate Professor of Anatomy', mobile: '7639985320', email: 'avhariraj@gmail.com' },
    { sl: 5, name: 'Dr. Divya Bharathy. R', designation: 'Member, Assistant Professor of Community Medicine', mobile: '7094344720', email: 'drdivyabharathy@gmail.com' },
    { sl: 6, name: 'Dr. A. Suphalakshmi', designation: 'Member, Dean of Engineering and Technology', mobile: '8925829052', email: 'deanfet@takshashilauniv.ac.in' },
    { sl: 7, name: 'Mr. P. Pattabiraman', designation: 'Member, Nominee from Police Department, S.I, Tindivanam Sub Division', mobile: '9498153099', email: 'palanipattabiraman@gmail.com' },
    {
      sl: 8,
      name: 'Students Representative',
      designation: (
        <>
          Ms. Mirudula Sree S J<br />
          Mr. Joshua Paul<br />
          Mr. Sujeeth G B
        </>
      ),
      mobile: (
        <>
          9500802935<br />
          8400526110<br />
          9751817361
        </>
      ),
      email: (
        <>
          mirudulasree8@gmail.com<br />
          fjoshuapaul5@gmail.com<br />
          sujeeth455@gmail.com
        </>
      ),
    },
    { sl: 9, name: 'Parents Representative', designation: 'Mr. Thirunavukkarasu R', mobile: '9952003954', email: 'thirunavukkarasusasirekha@gmail.com' },
    { sl: 10, name: 'Mrs. G.D. Vijayalakshmi', designation: 'Assistant Admin Manager (Non-Teaching Representative)', mobile: '9655386385', email: 'vijayalakshmiiswin@gmail.com' },
    { sl: 11, name: 'Dr. Prem kumar. K', designation: 'Secretary, Assistant Professor of Orthopaedics', mobile: '9003333273', email: 'premgmkmc@gmail.com' },
  ];

  const squadMembers = [
    { sl: 1, name: 'Dr. M. Jayasree', designation: 'Chairman, Dean', mobile: '9443769196', email: 'jayasreevyshali@gmail.com' },
    { sl: 2, name: 'Dr. Manibalan. V', designation: 'Professor - Physiology', mobile: '9941163012', email: 'dr.manibalan@gmail.com' },
    { sl: 3, name: 'Dr. Santhini Arulselvi', designation: 'Professor & HOD - Anatomy', mobile: '9842497987', email: 'ksanthiniarulselvi@gmail.com' },
    { sl: 4, name: 'Dr. Saranya. G', designation: 'Senior Resident - Community Medicine', mobile: '7845446121', email: 'Saru.sara3@gmail.com' },
    { sl: 5, name: 'Dr. M. Aljin Jino', designation: 'Assistant Professor - Psychiatry', mobile: '9487775991', email: 'Jino.aljin@gmail.com' },
    { sl: 6, name: 'Dr. J S Arun kumar', designation: 'Professor & HOD - Forensic Medicine & Toxicology', mobile: '9486113128', email: 'dr.arunjs.forensic@gmail.com' },
    { sl: 7, name: 'Dr. Gayathri. M', designation: 'Assistant Professor - OBG', mobile: '9500715222', email: 'drgayathrimohan18@gmail.com' },
    { sl: 8, name: 'Mr. M. Sivaraj', designation: 'Hostel Warden – Boys Hostel', mobile: '6383465493', email: 'sivaraj.m@takshashiauniv.ac.in' },
    { sl: 9, name: 'Mr. M. Vivek', designation: 'Hostel Warden – Boys Hostel', mobile: '8838298411', email: 'vivek.m@takshashiauniv.ac.in' },
    { sl: 10, name: 'Ms. Shmitha. R', designation: 'Hostel Warden – Girls Hostel', mobile: '9150593264', email: 'shmitha.r@takshashiauniv.ac.in' },
    { sl: 11, name: 'Mr. Dheeraj Kumar', designation: 'Hostel Manager', mobile: '9344005214', email: 'hostelmanager1@takshashiauniv.ac.in' },
  ];

  const pdfPath = '/assets/document/committee/anti-ragging/ANTI RAGGING COMMITTEE & SQUAD-2025.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Anti Ragging Committee & Squad - 2025</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Anti-Ragging Committee is formed to prevent and address issues of ragging on campus.
          It ensures a safe, respectful, and inclusive environment for all students by promoting
          awareness and enforcing strict anti-ragging policies.
        </p>
      </section>

      {/* Anti Ragging Committee */}
      <section className="pharma-table-section">
        <h2 className="ar-section-title">Anti Ragging Committee - 2025</h2>
        <div className="ar-table-wrapper">
          <table className="pharma-table ar-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Mobile No.</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              {committeeMembers.map((m) => (
                <tr key={m.sl}>
                  <td className="ar-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td className="ar-mobile" data-label="Mobile">{m.mobile}</td>
                  <td className="ar-email" data-label="Email">{m.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Anti Ragging Squad */}
      <section className="pharma-table-section">
        <h2 className="ar-section-title">Anti Ragging Squad - 2025</h2>
        <div className="ar-table-wrapper">
          <table className="pharma-table ar-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name</th>
                <th>Designation</th>
                <th>Mobile No.</th>
                <th>Email ID</th>
              </tr>
            </thead>
            <tbody>
              {squadMembers.map((m) => (
                <tr key={m.sl}>
                  <td className="ar-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name">{m.name}</td>
                  <td data-label="Designation">{m.designation}</td>
                  <td className="ar-mobile" data-label="Mobile">{m.mobile}</td>
                  <td className="ar-email" data-label="Email">{m.email}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Helpline */}
      <section className="ar-helpline">
        <span className="ar-helpline-label">National Anti Ragging Help Line</span>
        <span className="ar-helpline-number">1800-180-55-22</span>
      </section>

      {/* View Document Button */}
      <div className="ar-doc-btn-wrap">
        <a
          href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="ar-doc-btn"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default AntiRagging;
